import ItemDrawer from './ShortcutTooltip.container'

export default ItemDrawer
